import React, {useState, useEffect} from 'react';
// import { Table, Button, Form } from 'react-bootstrap';
// import { useState, useEffect } from 'react';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import Modal from 'react-bootstrap/Modal';
// import Organizations from './MaintenanceOrganizations';
// import Personnel from './MaintenancePersonnel';
// import Sites from './MaintenanceSites';
// import Devices from './MaintenanceDevices';

import Chart from './Chart'
//import { GaugeComponent } from 'react-gauge-component';
import ReactSpeedometer from "react-d3-speedometer";
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import BootstrapSwitchButton from 'bootstrap-switch-button-react';

//import TiltVisualizer from './TiltVisualizer';
//import AxisVisualizer from './AxisVisualizer';
import AngleLines from './AngleLines';
import ModernDial from "./ModernDial";
import ModernGauge from "./ModernGauge";

//import Toggle from 'react-bootstrap-toggle';
// const Maintenance = ({database, main_callback}) => {

//     if (database) {

//     //const organizations = database['organizations'];
//     //var personnel = database['personnel'];
//     //var sites = database['sites'];
//     //var devices = database['devices'];

//     console.log('Maintenance', database);

//     return (
//         <div>
//             <h1>Maintenance</h1>

//             <Tabs
//                 defaultActiveKey="organizations"
//                 id="maintenance-tabs"
//                 className="mb-3"
//                 fill
//                 >

//                 <Tab eventKey="organizations" title="Organizations">
//                     <Organizations organizations={database['organizations']} main_callback={main_callback}/>
//                 </Tab>
//                 <Tab eventKey="personnel" title="Personnel">
//                     {/* <Personnel personnel={personnel} main_callback={main_callback}/> */}
//                     <Personnel database={database} main_callback={main_callback}/>
//                 </Tab>
//                 <Tab eventKey="sites" title="Sites">
//                     <Sites database={database} main_callback={main_callback}/>
//                 </Tab>
//                 <Tab eventKey="devices" title="Devices">
//                     <Devices database={database} main_callback={main_callback}/>
//                 </Tab>
//             </Tabs>

//             <p>Savcor 2024</p>
//         </div>
 
//     )

//     }

// }
const ToggleSwitch = ({ checked, onChange, label }) => (
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "500",
      color: "#333",
    }}
  >
    <div
      style={{
        position: "relative",
        width: "52px",
        height: "28px",
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{
          opacity: 0,
          width: 0,
          height: 0,
        }}
      />
      <span
        style={{
          position: "absolute",
          inset: 0,
          background: checked
            ? "linear-gradient(135deg, #00c853, #b2ff59)"
            : "linear-gradient(135deg,rgb(20, 134, 241), rgb(158, 202, 243))",
          borderRadius: "999px",
          transition: "0.3s ease",
          boxShadow: "inset 0 0 4px rgba(7, 172, 248, 0.2)",
        }}
      />
      <span
        style={{
          position: "absolute",
          top: "4px",
          left: checked ? "28px" : "4px",
          width: "20px",
          height: "20px",
          background: "white",
          borderRadius: "50%",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
          transition: "left 0.3s ease",
        }}
      />
    </div>

    <span>{label}</span>

  </label>
);

/*
const ToggleSwitch = ({ checked, onChange, label }) => (
  <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
    <span>{label}</span>
    <div style={{ position: "relative", width: "48px", height: "24px" }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{ opacity: 0, width: 0, height: 0 }}
      />
      <span
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: checked ? "#4caf50" : "#ccc",
          borderRadius: "24px",
          transition: "0.4s",
        }}
      />
      <span
        style={{
          position: "absolute",
          content: "",
          height: "18px",
          width: "18px",
          left: checked ? "26px" : "4px",
          top: "3px",
          backgroundColor: "white",
          borderRadius: "50%",
          transition: "0.4s",
        }}
      />
    </div>
  </label>
);

*/






const LastMeasurements = ({ sensor, lastmeasurements }) => {
    console.log('!!lastmeasurements:', lastmeasurements.length, lastmeasurements[sensor])
    
    if (lastmeasurements[sensor] === undefined) //sensor == undefined || lastmeasurements == undefined )
        return;

    console.log('lastmeasurementsissa jotain', lastmeasurements)

    var result = '';
    result = lastmeasurements[sensor];


    console.log('parsered', JSON.stringify(result));//, parseredDatabase, ' => ', parseredDatabase['100000005'])
    // parsered {"time":"2025-04-16T07:22:23.60419325Z","timestamp":1744788143,"sensor":"100000005","battery_level":7, "temperature":27.0994,
    // "x_angle":0.546,"y_angle":0.2613,"z_angle":89.3947,"x_axis_acceleration":0.0096,"y_axis_acceleration":0.0046,"z_axis_acceleration":1.0025}
    //return JSON.stringify(result);

    let x_angle_with_offset = (result['x_angle_with_offset'] !== undefined) ? result['x_angle_with_offset'].toFixed(3) : 0.0;
    let y_angle_with_offset = (result['y_angle_with_offset'] !== undefined) ? result['y_angle_with_offset'].toFixed(3) : 0.0;
    let z_angle_with_offset = (result['z_angle_with_offset'] !== undefined) ? result['z_angle_with_offset'].toFixed(3) : 0.0;

    return (



        <div class="container">

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Sensor
                </div>
                <div class="col-md-9 d-flex align-items-left">
                    {result['sensor']}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Device id
                </div>
                <div class="col-md-9 d-flex align-items-left">
                    {result['device_id']}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Location id
                </div>
                <div class="col-md-9 d-flex align-items-left">
                    {result['location_id']}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Time
                </div>
                <div class="col-md-9 d-flex align-items-left">
                    {result['time']}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Temperature
                </div>
                <div class="col-md-9 d-flex align-items-left">
                    {result['temperature'] && result['temperature'].toFixed(1)}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Battery
                </div>
                <div class="col-md-9 d-flex align-items-left">
                    {result['battery_level']}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Angles
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    x
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    y
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    z
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Raw
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['x_angle'] && result['x_angle'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['y_angle'] && result['y_angle'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['z_angle'] && result['z_angle'].toFixed(3)}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Origin
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['x_angle_origin'] && result['x_angle_origin'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['y_angle_origin'] && result['y_angle_origin'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['z_angle_origin'] && result['z_angle_origin'].toFixed(3)}
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    incl offset
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['x_angle_with_offset'] && result['x_angle_with_offset'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['y_angle_with_offset'] && result['y_angle_with_offset'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['z_angle_with_offset'] && result['z_angle_with_offset'].toFixed(3)}
                </div>
            </div>


            <div class="row">
                <div class="col-md-3 d-flex align-items-left">
                    Accleration
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['x_axis_acceleration'] && result['x_axis_acceleration'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['y_axis_acceleration'] && result['y_axis_acceleration'].toFixed(3)}
                </div>
                <div class="col-md-3 d-flex align-items-left">
                    {result['z_axis_acceleration'] && result['z_axis_acceleration'].toFixed(3)}
                </div>
            </div>

{/*
            Sensor:{result['sensor']}<br/>
            Time: {result['time']}<br/>
            Angles: x:{result['x_angle']}, y:{result['y_angle']}, y:{result['z_angle']}<br/>
            Angles origin: x:{result['x_angle_origin']}, y:{result['y_angle_origin']}, y:{result['z_angle_origin']}<br/>
            Angles with offset: x:{x_angle_with_offset}, y:{y_angle_with_offset}, y:{z_angle_with_offset}<br/>
            Acceleration: x:{result['x_axis_acceleration']}, y:{result['y_axis_acceleration']}, y:{result['z_axis_acceleration']}<br/>
            Temperature: {result['temperature']}<br/>
            Battery level: {result['battery_level']}<br/>
            Device id: {result['device_id']}<br/>
            Location id: {result['location_id']}<br/>
*/}
        </div>
    )
}
/*
const Gauge2 = ({ database, lastmeasurement, gaugevalue }) => {

    //console.log('Gauge2:', address, lastmeasurement[address])
    //let value = (lastmeasurement[address] !== undefined) ? lastmeasurement[address]['x_angle_with_offset'].toFixed(3) : 0;

    let value = (gaugevalue !== undefined) ? gaugevalue.toFixed(3) : 0;

    return (
        <ReactSpeedometer
            minValue={-2}
            maxValue={2}
            value={value}
            segments={5}
            width={300}
            segmentColors={[
                "#f6961e",
                "#ecdb23",
                "#aee228",
                "#ecdb23",
                "#f6961e"
            ]}
        />
    )
}
*/



const Overview = ({ users, selectedUser, sites, locations, devices, database, lastmeasurements, callback }) => {

  const [value, setValue] = useState(98.7);


    const [selectedDevice, setSelectedDevice] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [locationAddress, setLocationAddress] = useState(null);

    // Käppyröiden haku oletuksena viimeiset 2 viikkoa
    const defaultStartDate = new Date();
    defaultStartDate.setDate(new Date().getDate() - 14);

    const [selectedStartDate, setSelectedStartDate] = useState(defaultStartDate);
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());    
    const [ chartOnline, setChartOnline ] = useState(true);

    var last = '';//lastMeasurements(database);
    var gaugevalue_x = 0;//JSON.parse(lastmeasurement)['x_angle'];// (lastmeasurement != undefined) ? lastmeasurement['x_angle'] : 5.0;
    var gaugevalue_y = 0;//JSON.parse(lastmeasurement)['y_angle'];// (lastmeasurement != undefined) ? lastmeasurement['x_angle'] : 5.0;
    var gaugevalue_z = 0;//JSON.parse(lastmeasurement)['z_angle'];// (lastmeasurement != undefined) ? lastmeasurement['x_angle'] : 5.0;


    console.log('overview test:', lastmeasurements)
    //var last = lastMeasurements(database);
    //console.log('wtf last measurements:', lastmeasurement != undefined && lastmeasurement['x_angle'])
    //console.log('wtf2:', JSON.parse(lastmeasurement)['x_angle'])
    try {
        if (locationAddress && locationAddress !== undefined) {
            gaugevalue_x = lastmeasurements[locationAddress]['x_angle_with_offset'];// (lastmeasurement != undefined) ? lastmeasurement['x_angle'] : 5.0;
            gaugevalue_y = lastmeasurements[locationAddress]['y_angle_with_offset'];// (lastmeasurement != undefined) ? lastmeasurement['x_angle'] : 5.0;
            gaugevalue_z = lastmeasurements[locationAddress]['z_angle_with_offset'];// (lastmeasurement != undefined) ? lastmeasurement['x_angle'] : 5.0;
        }
    }
    catch (error) {
        console.log('JSON parse error:', error)
    }
    


    console.log('last database', database)
    console.log('last', last)

    //console.log('wtf 2:', lastmeasurement)
    //console.log('wtf:', gaugevalue)
    //console.log('wtf 3:', JSON.parse(lastmeasurement)['x_angle'])


    // Tehdään käyttäjän aikarajausten perusteella tietokantahaku
    const queryDatabase = (online, location_id = null) => {
        console.log('TEST', online, location_id, selectedLocation)
        //(action, sender, data)
        
        // Location ei voi olla valitsematta
        if (location_id == null) {
            if (selectedLocation['location_id'])
                location_id = selectedLocation['location_id'];
            else
                return;
        }


        let action = 'query';
        let sender = 'overview';
        
        let data = new Object();
        data['command'] = 'query';
        data['device_id'] = (selectedDevice) ?  selectedDevice['device_id'] : null;

        // Online
        if (online) {
            data['begin'] = '-1h';//'-15m';
            data['end'] = 'now()';
        }
        // Historia
        else {
            data['begin'] = selectedStartDate.toISOString();
            data['end'] = selectedEndDate.toISOString();
            data['interval'] = '1h';
        }
        //data['interval']

        // Jos locationia vaihdetaan comboboxista, parametrina saadaan suoraan location_id. Muuten se ei olisi valmiina vielä selectedLocationissa.
        
        if (location_id) {
            data['location_id'] = location_id;
        }
        else {
            data['location_id'] = (selectedLocation) ? selectedLocation['location_id'] : null;
        }

        console.log('TEST location', selectedLocation, '/', location_id)
        callback(action, sender, data);
    }


    const SelectView = ({ }) => { // users, selectedUser, locations, devices}) => {
        return (
            <div class="container border rounded p-3">

                <div class="row">
                    <div class="col-sm-4">
                        <p>{selectedUser && selectedUser['username']}</p>
                        {/*
                        <Dropdown>
                            <Dropdown.Toggle variant="primary" id="dropdown-basic" className="w-100">
                                Select User
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                

                                {users && users.map((user, index) =>
                                    <Dropdown.Item
                                        key={index}
                                        >
                                        {user.description}
                                    </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                        */}
                    </div>

                    <div class="col-sm-8">
                        <p>{selectedUser && selectedUser['description']}</p>
                    </div>

                </div>

                <div class="row">
                    <div class="col-sm-12">

                        <Dropdown>
                            <Dropdown.Toggle variant="primary" id="dropdown-basic" className="w-100">
                                {selectedLocation && selectedLocation['description']}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {/*
                                <Dropdown.Item
                                    key={99999}
                                    onClick={() => {
                                        setSelectedLocation(null);
                                        setLocationAddress(null);
                                    }}                                         
                                    >
                                        Select location
                                </Dropdown.Item>
                                */}
                                {locations && locations
                                    .filter(location => location.user_id === selectedUser.user_id)  
                                    .map((location, index) =>
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() => { 
                                                setSelectedLocation(location);

                                                // Haetaan valittuun locationiin liitetyn laitteen address, jonka perusteella saadaan viimeisimmät mittaukset
                                                let dev_id = location['device_id'];
                                                let devFound = devices.find( element => element['device_id'] === dev_id );
                                                let address = (devFound) ? devFound['address'] : null;                                                
                                                setLocationAddress(address);

                                                // Tehdään haku samalla
                                                // Locationia vaihdettaessa annetaan suoraan myös locationin sensor address. 
                                                // Hae napilla haetaan jo selectedLocationissa oleva location_id
                                                //let test = location['location_id'];
                                                queryDatabase(chartOnline, location['location_id']);
                                            }}
                                            >
                                            {location.description}
                                        </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>

                    </div>
{/*
                    <div class="col-sm-8">
                        <p>{selectedLocation && selectedLocation['description']}</p>
                    </div>
*/}
                </div>
{/*
                <div class="row">
                    <div class="col-sm-8">
                        <p>{selectedDevice && selectedDevice['description']}</p>
                    </div>

                    <div class="col-sm-4">
                        <Dropdown>
                            <Dropdown.Toggle variant="success" id="dropdown-basic" className="w-100">
                                Select device
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    key={99999}
                                    onClick={() => setSelectedDevice(null)}
                                    >
                                        All
                                </Dropdown.Item>

                                {devices && devices
                                    .filter(device => device.user_id === selectedUser.user_id)  
                                    .map((device, index) =>
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() => { setSelectedDevice(device) }}
                                            >
                                            {device && device.description}
                                        </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
*/}

                <div class="row mt-2">

{/*
                <BootstrapSwitchButton
                    size="sm"
                    checked={chartOnline == "Online"}
                    onlabel="Auto" 
                    offlabel="Manual" 
                    onstyle="secondary"
                    offstyle="info"
                    style="w-75"
                    onChange={(checked) => {setChartOnline(!chartOnline)}}
                    >
                </BootstrapSwitchButton>
*/}

                <div class="col-sm-12">

                    <ToggleSwitch
                        checked={chartOnline}
                        onChange={() => {
                            const tmpOnlineStatus = !chartOnline;
                            setChartOnline(tmpOnlineStatus);
                            queryDatabase(tmpOnlineStatus);
                        }}
                        label={chartOnline ? "Online" : "Database"}
                    />


                    {/*
                    <Form>
                        <Form.Check
                            type="switch"
                            id="online_switch"
                            label={ (chartOnline) ? "Online" : "Database" }
                            checked={chartOnline}
                            onChange={() => {
                                // Otetaan talteen online-tila, johon ollaan siirtymässä ja annetaan tieto queryDatabaselle.
                                let tmpOnlineStatus = !chartOnline;
                                setChartOnline(!chartOnline);
                                queryDatabase(tmpOnlineStatus);
                                }
                            }
                            />
                    </Form>
                    */}
                </div>

                    <div class="col-sm-12">

                        <DatePicker className="w-100"
                            disabled={chartOnline}
                            selected={selectedStartDate}
                            onChange={(date) => { console.log('onChange:', date); setSelectedStartDate(date); }}
                            dateFormat="dd.MM.yyyy HH:mm"
                            showTimeSelect
                            timeFormat="HH:mm"
                        />

                        <DatePicker className="w-100"
                            disabled={chartOnline}
                            selected={selectedEndDate}
                            onChange={(date) => { setSelectedEndDate(date); }}
                            dateFormat="dd.MM.yyyy HH:mm"
                            showTimeSelect
                            timeFormat="HH:mm"
                        />


                </div>
</div>                
                <div class="row">
                    <div class="col-sm-8">

                    </div>

                    <div class="col-sm-4">
                        <button disabled={chartOnline} class="btn btn-primary m-2 w-75" onClick={() => queryDatabase(false)}>Hae</button>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <div className="ms-4 me-4">
            <h1>Overview</h1>
            
            <div className="row">

                <div className="col-sm-3">
                    <SelectView users={users} selectedUser={selectedUser} locations={locations} devices={devices}></SelectView>
                </div>

                <div className="col-sm-3 border rounded p-3">
                    <LastMeasurements sensor={locationAddress} lastmeasurements={lastmeasurements} />
                </div>



                <div className="col-sm-2 d-flex flex-column align-items-center justify-content-center">
                    {/*<Gauge2 database={database} lastmeasurements={lastmeasurements} gaugevalue={gaugevalue_x} />*/}
                    <ModernGauge value={gaugevalue_x} min={-2} max={+2} class="border rounded p-3" />
                    <ModernDial value={gaugevalue_x} />
                </div>
                <div className="col-sm-2 d-flex flex-column align-items-center justify-content-center">
                    <ModernGauge value={gaugevalue_y} min={-2} max={+2} />
                    <ModernDial value={gaugevalue_y} />
                </div>
                <div className="col-sm-2 d-flex flex-column align-items-center justify-content-center">
                    <ModernGauge value={gaugevalue_z} min={-2} max={+2} />
                    <ModernDial value={gaugevalue_z} />
                </div>


            {/*
                <div class="col-sm-3">
                    <AngleLines sensor={locationAddress} lastmeasurements={lastmeasurements} />
                </div>
*/}
            </div>


            <Chart database={database} />


{/*
   <div style={{ background: '#000', minHeight: '100vh', padding: '2rem', color: 'white' }}>
      <h2>3D Axis Visualizer</h2>
      <AxisVisualizer x={x} y={y} z={z} />
      <p>X: {x.toFixed(2)}, Y: {y.toFixed(2)}, Z: {z.toFixed(2)}</p>
    </div>

    <div style={{ background: '#000', minHeight: '100vh', padding: '2rem', color: 'white' }}>
      <h2>Tilt Visualizer</h2>
      <TiltVisualizer pitch={pitch} roll={roll} />
      <p>Pitch: {pitch.toFixed(1)}°, Roll: {roll.toFixed(1)}°</p>
    </div>

        */}
    </div>
    )
}


export default Overview

